import React, {useMemo, useRef} from 'react'
import Text from '../../../../components/text/Text'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizSelectButton from '../../../../components/button/WizSelectButton'
import WizImage from '../../../../components/image/WizImage'
import img_lot_main from '../../../../assets/images/img_lot_main.jpg'
import {postUploadImage} from '../../../../apis/image/postUploadImage'
import {ICreateCampaignState} from '../../../../pages/leaderboard/Campaign/CampaignCreatePage'
import WizSelect from '../../../../components/select/WizSelect'

interface IProps {
    className?: string
    data?: ICreateCampaignState
    setData?: (e) => void
}

const KoreanCampaign: React.FC<IProps> = ({className, data, setData}) => {
    const actionList = useMemo(
        () => [
            {id: 'web', value: 'Web'},
            {id: 'post', value: 'Post'},
            {id: 'league', value: 'League'},
            {id: 'deeplink', value: 'DeepLink'},
        ],
        [],
    )

    const onChangeThumbnail = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)

            setData({...data, background_image: result?.image_url})
        }
    }
    const bgImageRef = useRef<any>()

    const renderActionPlaceholder = () => {
        if (data?.action_type === 'web') {
            return 'Click Link (Web Link)'
        } else if (data?.action_type === 'post') {
            return 'Click Link (Post Id)'
        } else if (data?.action_type === 'league') {
            return 'Click Link (League Id)'
        } else {
            return 'Click Link (Deep Link)'
        }
    }

    const onChangeFunction = e => {
        setData({...data, action: '', action_type: e})
    }

    return (
        <div
            className={
                'w-[480px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[35px] space-y-[30px] md:w-full'
            }>
            <Text className={'text-h3 text-center sm:text-h1'}>Korean Campaign</Text>
            <div className={''}>
                <Text className={'text-body3 text-font02'}>Name</Text>
                <UnderLineInput
                    className={'w-full'}
                    onChanged={text => {
                        setData({...data, name: text})
                    }}
                />
            </div>

            <div className={'space-y-[3px] md:space-y-[7px]'}>
                <Text className={'text-body3 text-font02 text-center'}>Link Type</Text>
                <WizSelectButton
                    className={'mx-auto md:hidden'}
                    data={actionList}
                    onChange={e => {
                        setData({...data, action: '', action_type: e.id})
                    }}
                    activeValue={actionList?.find(item => item.id === data?.action_type)}
                />
                <WizSelect
                    optionKey="campaign_action_type"
                    className={'hidden md:block md:mx-auto md:w-min'}
                    onChange={onChangeFunction}
                />
            </div>

            <div className={''}>
                <Text className={'text-body3 text-font02'}>Click Link</Text>
                <UnderLineInput
                    placeholder={renderActionPlaceholder()}
                    value={data?.action}
                    onChanged={text => {
                        setData({...data, action: text})
                    }}
                />
            </div>
            <div className={'flex justify-between items-center gap-x-[30px]'}>
                <div className={'flex-1'}>
                    <Text className={'text-body3 text-font02'}>Background Color (Dark Mode)</Text>
                    <div className={'flex items-center gap-x-[5px]'}>
                        <UnderLineInput
                            placeholder={'#FFFFFF'}
                            onChanged={text => {
                                setData({...data, background_color: {...data.background_color, dark: text}})
                            }}
                        />
                        <div
                            style={{backgroundColor: data?.background_color?.dark}}
                            className={'w-[16px] h-[16px] rounded-[5px] border border-line01'}
                        />
                    </div>
                </div>
                <div className={'flex-1'}>
                    <Text className={'text-body3 text-font02'}>Background Color (Light Mode)</Text>
                    <div className={'flex items-center gap-x-[5px]'}>
                        <UnderLineInput
                            placeholder={'#000000'}
                            onChanged={text => {
                                setData({...data, background_color: {...data.background_color, light: text}})
                            }}
                        />
                        <div
                            style={{backgroundColor: data?.background_color?.light}}
                            className={'w-[16px] h-[16px] rounded-[5px] border border-line01'}
                        />
                    </div>
                </div>
            </div>

            <div className={'flex justify-between items-end gap-x-[30px]'}>
                <div className={'flex-1'}>
                    <Text className={'text-body3 text-font02'}>Background Image (Korean)</Text>
                    <div
                        onClick={() => bgImageRef?.current?.click()}
                        className={
                            'border border-line02 rounded-[10px] overflow-hidden w-full mt-[10px] cursor-pointer flex relative'
                        }>
                        <div className={'relative brightness-50'}>
                            <WizImage src={img_lot_main} />
                        </div>
                        {data?.background_image && (
                            <div
                                style={{backgroundColor: data?.background_color?.dark}}
                                className={'w-full absolute bottom-0 left-0 z-[1] pt-[20px] rounded-[10px]'}>
                                <WizImage src={`${data?.background_image}?type=webp&width=1920`} />
                            </div>
                        )}
                    </div>
                    <input type={'file'} onChange={e => onChangeThumbnail(e)} ref={bgImageRef} className={'hidden'} />
                </div>
            </div>
        </div>
    )
}

export default KoreanCampaign
